<script>
    import css from "./maintenance.css";

    export let error;
    export let orderId;

    const i18n = window.strings.errors.buyGems;

    let _i18n = i18n;

    if (error.error === "steam") {
        _i18n = i18n.steam;
    } else if (error.error === "bep") {
        _i18n = i18n.bep;
    }
</script>

<h1>{_i18n.header}</h1>

<p>{_i18n.intro}</p>

<!-- <p>{JSON.stringify(error)}</p> -->

{#if orderId}
    <p class={css.orderId}>
        {i18n.orderId}
        {orderId}
    </p>
{/if}

{#if error.errorCode}
    <p class={css.errorCode}>
        {i18n.code}
        {error.errorCode}
    </p>
{/if}
